module.exports = __webpack_public_path__ + "static/images/checkmark-green.36ec3864be98403a9b52d1c298fd9087.svg";